"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[209],{

/***/ 8181:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/patternBG.e607d2cb.png","height":1364,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAQAAABUDBdwAAAAOklEQVR42kXJUQrAIAwE0a0m0pZSvf9hB1E07tcyTxLOj+uMm0ZZ/xIZwwKzKKStk/AIL3UEi/DwkTrhixpkdjflIAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 5462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(6265);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-stickynode/dist/es/Sticky.js + 11 modules
var Sticky = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(795);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(6261);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./src/components/link.js
var components_link = __webpack_require__(8055);
;// CONCATENATED MODULE: ./src/components/logo.js
/** @jsxImportSource theme-ui */ 





function Logo(_param) {
    var src = _param.src, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(components_link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        path: "/",
        sx: {
            variant: "links.logo",
            display: "flex",
            cursor: "pointer",
            mr: 15
        }
    }, rest), {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
            src: src,
            alt: "startup landing logo"
        })
    }));
};

;// CONCATENATED MODULE: ./src/assets/theiastream_logo_dark.png
/* harmony default export */ var theiastream_logo_dark = ({"src":"/_next/static/media/theiastream_logo_dark.5ec5bcb8.png","height":50,"width":243,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAAKElEQVR42mNoMGwwr/dpiKz3qVcEQhWGeo161XqNBpt68wa1Bs16EQDDUgsBZwLGhQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/theiastream_logo.png
/* harmony default export */ var theiastream_logo = ({"src":"/_next/static/media/theiastream_logo.5a08188e.png","height":50,"width":243,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAAJklEQVR42mP4Z/jP/J/Pv0ggVgRCFYZ/Gv9Ugdjmn/k/tX+a/0QATdoS6y8nx6wAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/contexts/drawer/drawer.context.js

var DrawerContext = /*#__PURE__*/ (0,react.createContext)({});

;// CONCATENATED MODULE: ./src/contexts/drawer/drawer.provider.js





var initialState = {
    isOpen: false
};
function reducer(state, action) {
    switch(action.type){
        case "TOGGLE":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isOpen: !state.isOpen
            });
        default:
            return state;
    }
}
var DrawerProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useReducer)(reducer, initialState), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/react-custom-scrollbars/lib/index.js
var lib = __webpack_require__(1298);
// EXTERNAL MODULE: ./node_modules/rc-drawer/es/index.js + 56 modules
var es = __webpack_require__(5023);
;// CONCATENATED MODULE: ./src/components/drawer.js







var Drawer = function(_param) {
    var className = _param.className, children = _param.children, closeButton = _param.closeButton, closeButtonStyle = _param.closeButtonStyle, drawerHandler = _param.drawerHandler, toggleHandler = _param.toggleHandler, open = _param.open, width = _param.width, placement = _param.placement, drawerStyle = _param.drawerStyle, closeBtnStyle = _param.closeBtnStyle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children",
        "closeButton",
        "closeButtonStyle",
        "drawerHandler",
        "toggleHandler",
        "open",
        "width",
        "placement",
        "drawerStyle",
        "closeBtnStyle"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                open: open,
                onClose: toggleHandler,
                className: "drawer ".concat(className ? className : "").trim(),
                width: width,
                placement: placement,
                handler: false,
                level: null,
                duration: "0.4s"
            }, props), {
                children: [
                    closeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Box */.xu, {
                        as: "div",
                        onClick: toggleHandler,
                        sx: closeBtnStyle,
                        children: closeButton
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Box */.xu, {
                        sx: drawerStyle,
                        children: children
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Box */.xu, {
                className: "drawer__handler",
                style: {
                    display: "inline-block"
                },
                onClick: toggleHandler,
                children: drawerHandler
            })
        ]
    });
};
Drawer.defaultProps = {
    width: "320px",
    placement: "left"
};
/* harmony default export */ var drawer = (Drawer);

// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(1649);
;// CONCATENATED MODULE: ./src/components/header/header.data.js
/* harmony default export */ var header_data = ([
    {
        path: "home",
        label: "Home"
    },
    {
        path: "feature",
        label: "Features"
    },
    {
        path: "pricing",
        label: "Pricing"
    },
    {
        path: "contact",
        label: "Contact"
    }, 
]);

;// CONCATENATED MODULE: ./src/components/header/mobile-drawer.js










var MobileDrawer = function() {
    var ref = (0,react.useContext)(DrawerContext), state = ref.state, dispatch = ref.dispatch;
    // Toggle drawer
    var toggleHandler = react.useCallback(function() {
        dispatch({
            type: "TOGGLE"
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer, {
        width: "320px",
        drawerHandler: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Box */.xu, {
            sx: styles.handler,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdMenu */.tgG, {
                size: "26px"
            })
        }),
        open: state.isOpen,
        toggleHandler: toggleHandler,
        closeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdClose */.QAE, {
            size: "24px",
            color: "#000000"
        }),
        drawerStyle: styles.drawer,
        closeBtnStyle: styles.close,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Scrollbars */.$B, {
            autoHide: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Box */.xu, {
                sx: styles.content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_ui_components_esm/* Box */.xu, {
                    sx: styles.menu,
                    children: header_data.map(function(param, i) {
                        var path = param.path, label = param.label;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                            activeClass: "active",
                            to: path,
                            spy: true,
                            smooth: true,
                            offset: -70,
                            duration: 500,
                            children: label
                        }, i);
                    })
                })
            })
        })
    });
};
var styles = {
    handler: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0",
        width: "26px",
        cursor: "pointer",
        "@media screen and (min-width: 1024px)": {
            display: "none"
        }
    },
    drawer: {
        width: "100%",
        height: "100%",
        backgroundColor: "dark"
    },
    close: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "25px",
        right: "30px",
        zIndex: "1",
        cursor: "pointer"
    },
    content: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        pt: "100px",
        pb: "40px",
        px: "30px"
    },
    menu: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        a: {
            fontSize: "16px",
            fontWeight: "500",
            color: "text_white",
            py: "15px",
            cursor: "pointer",
            borderBottom: "1px solid #e8e5e5",
            transition: "all 0.25s",
            "&:hover": {
                color: "secondary"
            },
            "&.active": {
                color: "secondary"
            }
        }
    },
    menuFooter: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: "auto"
    },
    social: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        icon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text",
            fontSize: 14,
            mr: "15px",
            transition: "all 0.25s",
            cursor: "pointer",
            ":last-child": {
                mr: "0"
            },
            "&:hover": {
                color: "secondary"
            }
        }
    },
    button: {
        color: "white",
        fontSize: "14px",
        fw: "700",
        height: "45px",
        borderRadius: "5px",
        cursor: "pointer",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: "0"
    }
};
/* harmony default export */ var mobile_drawer = (MobileDrawer);

;// CONCATENATED MODULE: ./src/components/header/header.js
/** @jsxImportSource theme-ui */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    position: fixed;\n    opacity: 1;\n  }\n  to {\n    position: absolute;\n    opacity: 1;\n    transition: all 0.4s ease;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










function Header(param) {
    var _navHidden = param.navHidden, navHidden = _navHidden === void 0 ? "false" : _navHidden, _title = param.title, title = _title === void 0 ? null : _title, className = param.className;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(DrawerProvider, {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("header", {
            sx: header_styles.header,
            className: className,
            id: "header",
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
                sx: header_styles.container,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Logo, {
                        src: className === "sticky" ? theiastream_logo_dark.src : theiastream_logo.src
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                        as: "h2",
                        sx: {
                            variant: "sectionHeader.title",
                            color: className === "sticky" ? "heading_secondary" : "white"
                        },
                        children: title
                    }),
                    navHidden === "false" && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                                as: "nav",
                                sx: header_styles.nav,
                                children: header_data.map(function(param, i) {
                                    var path = param.path, label = param.label;
                                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(modules/* Link */.rU, {
                                        activeClass: "active",
                                        to: path,
                                        spy: true,
                                        smooth: true,
                                        offset: -70,
                                        duration: 500,
                                        children: label
                                    }, i);
                                })
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(mobile_drawer, {})
                        ]
                    })
                ]
            })
        })
    });
};
var positionAnim = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject());
var header_styles = {
    header: {
        color: "white",
        fontWeight: "normal",
        py: 4,
        width: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        backgroundColor: "transparent",
        transition: "all 0.5s ease",
        animation: "".concat(positionAnim, " 0.4s ease"),
        ".donate__btn": {
            flexShrink: 0,
            mr: [
                15,
                20,
                null,
                null,
                0
            ],
            ml: [
                "auto",
                null,
                null,
                null,
                0
            ]
        },
        "&.sticky": {
            position: "fixed",
            backgroundColor: "background",
            color: "#000000",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.06)",
            py: 3,
            "nev > a": {
                color: "text"
            },
            ".donate__btn": {
                borderColor: "primary",
                color: "primary",
                "&:hover": {
                    boxShadow: "rgba(31, 62, 118, 0.57) 0px 9px 20px -5px",
                    backgroundColor: "primary",
                    color: "white"
                }
            }
        }
    },
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    nav: {
        mx: "auto",
        display: "none",
        "@media screen and (min-width: 1024px)": {
            display: "block"
        },
        a: {
            fontSize: "16px",
            fontWeight: "400",
            px: 25,
            cursor: "pointer",
            lineHeight: "1.2",
            "&.active": {
                color: "secondary"
            }
        }
    }
};

;// CONCATENATED MODULE: ./src/components/footer/footer.data.js
/* harmony default export */ var footer_data = ([
    {
        header: "About Us",
        items: [
            {
                path: "/",
                label: "Support Center"
            },
            {
                path: "/",
                label: "Customer Support"
            },
            {
                path: "/",
                label: "About Us"
            },
            {
                path: "/",
                label: "Copyright"
            },
            {
                path: "/",
                label: "Popular Campaign"
            }, 
        ]
    },
    {
        header: "Our Information",
        items: [
            {
                path: "/",
                label: "Return Policy "
            },
            {
                path: "/",
                label: "Privacy Policy"
            },
            {
                path: "/",
                label: "Terms & Conditions"
            },
            {
                path: "/",
                label: "Site Map"
            },
            {
                path: "/",
                label: "Store Hours"
            }, 
        ]
    },
    {
        header: "My Account",
        items: [
            {
                path: "/",
                label: "Press inquiries"
            },
            {
                path: "/",
                label: "Social media "
            },
            {
                path: "/",
                label: "directories"
            },
            {
                path: "/",
                label: "Images & B-roll"
            },
            {
                path: "/",
                label: "Permissions"
            }, 
        ]
    },
    {
        header: "Policy",
        items: [
            {
                path: "/",
                label: "Application security"
            },
            {
                path: "/",
                label: "Software principles"
            },
            {
                path: "/",
                label: "Unwanted software policy"
            },
            {
                path: "/",
                label: "Responsible supply chain"
            }, 
        ]
    }, 
]);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
;// CONCATENATED MODULE: ./src/components/footer/footer.js
/** @jsxImportSource theme-ui */ 






function Footer(props) {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("footer", {
        sx: props.fixed == "true" ? footer_styles.footer.fixed : footer_styles.footer,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Row/* default */.Z, {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(Col/* default */.Z, {
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(components_link/* Link */.r, {
                            path: "/policies/privacy",
                            label: "Privacy Policy",
                            sx: footer_styles.footer.link
                        }),
                        " - ",
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(components_link/* Link */.r, {
                            path: "/policies/terms",
                            label: "Terms and Conditions",
                            sx: footer_styles.footer.link
                        }),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("br", {}),
                        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Text */.xv, {
                            sx: footer_styles.footer.copyright,
                            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("strong", {
                                children: "Copyright \xa9 2023 Theia Stream, LLC."
                            })
                        })
                    ]
                })
            })
        })
    });
};
var footer_styles = {
    footer: {
        backgroundColor: "#F6F6F6",
        fixed: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            backgroundColor: "#F6F6F6"
        },
        container: {
            width: "100%",
            alignItems: "stretch"
        },
        link: {
            fontSize: [
                "14px",
                null,
                1
            ],
            fontWeight: "body",
            color: "text",
            cursor: "pointer",
            textDecoration: "none",
            ":hover": {
                color: "primary"
            }
        },
        copyright: {
            fontSize: [
                "14px",
                null,
                1
            ],
            width: "100%",
            textAlign: "center",
            color: "text",
            a: {
                textDecoration: "none",
                color: "inherit",
                pl: 1,
                transition: "all 0.25s",
                "&:hover": {
                    color: "primary"
                }
            }
        }
    }
};

;// CONCATENATED MODULE: ./src/components/layout.js
/** @jsxImportSource theme-ui */ 





function Layout(param) {
    var children = param.children, _navHidden = param.navHidden, navHidden = _navHidden === void 0 ? "false" : _navHidden, _title = param.title, title = _title === void 0 ? null : _title, _fixedFooter = param.fixedFooter, fixedFooter = _fixedFooter === void 0 ? "false" : _fixedFooter;
    var ref = (0,react.useState)(false), isSticky = ref[0], setIsSticky = ref[1];
    var handleStateChange = function(status) {
        if (status.status === Sticky/* default.STATUS_FIXED */.Z.STATUS_FIXED) {
            setIsSticky(true);
        } else if (status.status === Sticky/* default.STATUS_ORIGINAL */.Z.STATUS_ORIGINAL) {
            setIsSticky(false);
        }
    };
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Sticky/* default */.Z, {
                innerZ: 1001,
                top: 0,
                onStateChange: handleStateChange,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header, {
                    navHidden: navHidden,
                    title: title,
                    className: "".concat(isSticky ? "sticky" : "unSticky")
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("main", {
                sx: {
                    variant: "layout.main"
                },
                children: children
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Footer, {
                fixed: fixedFooter
            })
        ]
    });
};


/***/ }),

/***/ 8055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export NavLink */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6265);
/* harmony import */ var theme_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(795);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/** @jsxImportSource theme-ui */ 





function NavLink(_param) {
    var path = _param.path, label = _param.label, children = _param.children, rest = _object_without_properties(_param, [
        "path",
        "label",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(NextLink, {
        href: path,
        children: /*#__PURE__*/ _jsx(MenuLink, _object_spread_props(_object_spread({}, rest), {
            children: children ? children : label
        }))
    });
}
function Link(_param) {
    var path = _param.path, label = _param.label, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "path",
        "label",
        "children"
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(theme_ui__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
        href: path,
        children: children ? children : label
    }));
}


/***/ }),

/***/ 687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nK": function() { return /* binding */ StickyProvider; }
});

// UNUSED EXPORTS: useStickyDispatch, useStickyState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/contexts/create-context.js



function useCreateContext(defaultValue, reducer) {
    var useStateCtx = function useStateCtx(property) {
        var state = (0,react.useContext)(stateCtx);
        return state[property]; // only one depth selector for comparison
    };
    var useDispatchCtx = function useDispatchCtx() {
        return (0,react.useContext)(dispatchCtx);
    };
    var Provider = function Provider(param) {
        var children = param.children;
        var ref = (0,_sliced_to_array/* default */.Z)(react.useReducer(reducer, defaultValue), 2), state = ref[0], dispatch = ref[1];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dispatchCtx.Provider, {
            value: dispatch,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stateCtx.Provider, {
                value: state,
                children: children
            })
        });
    };
    var defaultDispatch = function() {
        return defaultValue;
    };
    var stateCtx = /*#__PURE__*/ (0,react.createContext)(defaultValue);
    var dispatchCtx = /*#__PURE__*/ (0,react.createContext)(defaultDispatch);
    return [
        useStateCtx,
        useDispatchCtx,
        Provider
    ];
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./src/contexts/app/app.reducer.js


var initialState = {
    isSticky: false,
    isSidebarSticky: true
};
function reducer(state, param) {
    var type = param.type;
    switch(type){
        case "SET_STICKY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSticky: true
            });
        case "REMOVE_STICKY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSticky: false
            });
        case "SET_SIDEBAR_STICKY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSidebarSticky: true
            });
        case "REMOVE_SIDEBAR_STICKY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isSidebarSticky: false
            });
        default:
            {
                throw new Error("Unsupported action type: ".concat(type));
            }
    }
}

;// CONCATENATED MODULE: ./src/contexts/app/app.provider.js



var ref = (0,_sliced_to_array/* default */.Z)(useCreateContext(initialState, reducer), 3), state = ref[0], useDispatch = ref[1], provider = ref[2];
var useStickyState = (/* unused pure expression or super */ null && (state));
var useStickyDispatch = (/* unused pure expression or super */ null && (useDispatch));
var StickyProvider = provider;


/***/ }),

/***/ 6690:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    // example colors with dark mode
    colors: {
        text: "#343D48",
        text_secondary: "#02073E",
        heading: "#244886",
        heading_secondary: "#0F2137",
        background: "#FFFFFF",
        background_secondary: "#F9FBFD",
        border_color: "#E5ECF4",
        primary: "#1F3E76",
        secondary: "#25CB9E",
        muted: "#7B8188",
        accent: "#609",
        yellow: "#F6C416",
        // highlight	a background color for highlighting text
        modes: {
        }
    },
    breakpoints: [
        "480px",
        "640px",
        "768px",
        "1024px",
        "1220px",
        "1366px",
        "1620px", 
    ],
    fonts: {
        body: "'DM Sans', sans-serif",
        heading: "'DM Sans', sans-serif"
    },
    fontSizes: [
        12,
        15,
        16,
        18,
        20,
        22,
        24,
        28,
        32,
        36,
        42,
        48,
        52,
        64
    ],
    fontWeights: {
        body: "normal",
        heading: 500,
        bold: 700
    },
    lineHeights: {
        body: 1.8,
        heading: 1.5
    },
    letterSpacings: {
        body: "normal",
        caps: "0.2em",
        heading: "-0.5px"
    },
    space: [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        50,
        80,
        100,
        120,
        150
    ],
    // variants can use custom, user-defined names
    layout: {
        container: {
            maxWidth: [
                "100%",
                null,
                null,
                "780px",
                "1020px",
                "1200px",
                null,
                "1310px", 
            ],
            px: [
                4,
                6
            ]
        },
        header: {
            color: "#02073E",
            fontWeight: "normal",
            py: 3,
            position: "absolute",
            width: "100%"
        },
        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        },
        main: {}
    },
    section: {
        keyFeature: {
            py: [
                8,
                null,
                9,
                null,
                null,
                10
            ]
        },
        feature: {
            py: [
                8,
                null,
                9,
                null,
                null,
                10
            ]
        },
        partner: {
            pt: [
                2,
                null,
                null,
                5
            ],
            pb: [
                8,
                null,
                9,
                null,
                null,
                10
            ]
        },
        testimonial: {
            py: [
                8,
                null,
                9,
                null,
                null,
                10
            ],
            overflow: "hidden"
        },
        securePayment: {
            overflow: "hidden",
            position: "relative",
            pt: 9
        },
        faq: {
            py: [
                8,
                null,
                9,
                null,
                null,
                10
            ]
        }
    },
    sectionHeader: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: -1,
        marginBottom: [
            "50px",
            null,
            "60px",
            null,
            "65px",
            "75px"
        ],
        title: {
            fontSize: [
                "24px",
                null,
                "28px",
                null,
                null,
                "32px",
                null,
                "36px"
            ],
            color: "heading_secondary",
            lineHeight: [
                1.3,
                null,
                null,
                1.2
            ],
            textAlign: "center",
            fontWeight: "700",
            letterSpacing: "-.5px"
        },
        subTitle: {
            fontSize: [
                0,
                null,
                "14px"
            ],
            color: "heading",
            textAlign: "center",
            letterSpacing: [
                "1.5px",
                null,
                "2px"
            ],
            textTransform: "uppercase",
            fontWeight: "700",
            mb: "8px",
            lineHeight: 1.5
        }
    },
    text: {
        heading: {
            fontFamily: "heading",
            lineHeight: "heading",
            fontWeight: "heading",
            fontSize: 4,
            letterSpacing: "heading",
            color: "heading"
        },
        heroPrimary: {
            color: "white",
            fontSize: [
                "32px",
                "32px",
                "32px",
                "32px",
                "48px",
                "48px",
                "54px",
                "54px", 
            ],
            lineHeight: 1.2,
            fontWeight: 700,
            mb: [
                5,
                null,
                null,
                null,
                "30px"
            ]
        },
        heroSecondary: {
            color: "white",
            fontSize: [
                2,
                3,
                4,
                "17px",
                null,
                3,
                "19px",
                4
            ],
            lineHeight: [
                2,
                null,
                null,
                null,
                2.2
            ],
            fontWeight: "body",
            pr: [
                0,
                null,
                null,
                null,
                null,
                "100px",
                null,
                "125px"
            ],
            mb: [
                "35px",
                null,
                null,
                null,
                "40px",
                null,
                null,
                7
            ]
        },
        title: {
            // extends the text.heading styles
            variant: "text.heading",
            fontWeight: "bold",
            fontSize: 18,
            lineHeight: "30px",
            color: "#0F2137"
        },
        lead: {
            fontSize: 40,
            fontFamily: "DM Sans",
            fontWeight: "500",
            lineHeight: "60px",
            letterSpacing: "-1.5px",
            color: "#0F2137"
        },
        muted: {
            lineHeight: "26px",
            color: "muted"
        },
        secondary: {
            fontWeight: 500,
            color: "#00A99D",
            lineHeight: "40px"
        }
    },
    links: {
        default: {
            cursor: "pointer"
        },
        bold: {
            fontWeight: "bold"
        },
        nav: {
            display: [
                "none",
                null,
                "inline-block"
            ],
            px: 25,
            fontWeight: "normal"
        },
        footer: {
            display: "block",
            px: 0,
            color: "inherit",
            textDecoration: "none"
        },
        logo: {
            display: "flex"
        }
    },
    images: {
        avatar: {
            width: 48,
            height: 48,
            borderRadius: 99999
        }
    },
    // variants for buttons
    buttons: {
        menu: {
            display: [
                null,
                null,
                "none"
            ]
        },
        // you can reference other values defined in the theme
        defaultBtn: {
            borderRadius: "45px",
            fontSize: [
                "14px",
                1,
                null,
                null,
                2
            ],
            letterSpacings: [
                "-0.5px",
                null,
                null,
                null,
                "-0.15px"
            ],
            padding: [
                "11px 20px 10px",
                null,
                null,
                null,
                "13px 30px"
            ],
            fontFamily: "body",
            cursor: "pointer",
            lineHeight: 1.2,
            transition: "all 0.25s",
            fontWeight: 500,
            "&:focus": {
                outline: 0
            }
        },
        primary: {
            variant: "buttons.defaultBtn",
            color: "white",
            bg: "primary",
            "&:hover": {
                boxShadow: "rgba(31, 62, 118, 0.57) 0px 9px 20px -5px"
            }
        },
        whiteButton: {
            variant: "buttons.defaultBtn",
            color: "heading_secondary",
            bg: "white"
        },
        grayButton: {
            variant: "buttons.defaultBtn",
            color: "heading_secondary",
            bg: "gray",
            "&:hover": {
                boxShadow: "rgba(0, 0, 0, 0.5) 0px 12px 24px -10px"
            }
        },
        secondary: {
            variant: "buttons.defaultBtn",
            border: "1.5px solid white",
            backgroundColor: "transparent",
            color: "white",
            "&:hover": {
                bg: "white",
                color: "heading_secondary"
            }
        },
        textButton: {
            variant: "buttons.defaultBtn",
            backgroundColor: "transparent",
            color: "white",
            display: "flex",
            alignItems: "center",
            svg: {
                fontSize: [
                    4,
                    6
                ],
                mr: 2
            }
        }
    },
    cards: {
        primary: {
            padding: 2,
            borderRadius: 4
        },
        offer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flex: [
                "1 1 calc(50% - 16px)",
                "1 1 20%"
            ],
            minHeight: 130,
            m: 2,
            background: "#FFFFFF",
            border: "1px solid #EDEFF6",
            borderRadius: 5
        },
        featureCard: {
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "row",
            p: 3
        }
    },
    forms: {
        label: {
            fontSize: 1,
            fontWeight: "bold"
        },
        input: {
            borderRadius: 8,
            borderColor: "border_color",
            height: 60,
            "&:focus": {
                borderColor: "primary",
                boxShadow: function(t) {
                    return "0 0 0 2px ".concat(t.colors.primary);
                },
                outline: "none"
            }
        }
    },
    badges: {
        primary: {
            color: "background",
            bg: "#28A5FF",
            borderRadius: 30,
            p: "3px 11px",
            fontSize: 1,
            letterSpacing: "-0.5px"
        },
        outline: {
            color: "primary",
            bg: "transparent",
            boxShadow: "inset 0 0 0 1px"
        }
    },
    styles: {
        // To add base, top-level styles to the <body> element, use theme.styles.root.
        root: {
            fontFamily: "body",
            lineHeight: "body",
            fontWeight: "body",
            fontSmoothing: "antialiased",
            ".modal-video-close-btn": {
                cursor: "pointer",
                top: "-25px",
                right: "-25px",
                width: " 25px",
                height: "25px"
            },
            ".modal-video-movie-wrap": {
                margin: 6,
                width: "auto"
            }
        },
        // Divider styles
        hr: {
            border: 0,
            borderBottom: "1px solid",
            borderColor: "#D9E0E7"
        },
        // also you can use other HTML elements style here
        ul: {
            listStyle: "none"
        },
        srOnly: {
            border: "0 !important",
            clip: "rect(1px, 1px, 1px, 1px) !important",
            clipPath: "inset(50%) !important",
            height: "1px !important",
            margin: "-1px !important",
            overflow: "hidden !important",
            padding: "0 !important",
            position: "absolute !important",
            width: "1px !important",
            whiteSpace: "nowrap !important"
        }
    }
});


/***/ })

}]);